import { useState } from 'react';
import type { GridApi, RowClickedEvent, RowSelectedEvent } from 'ag-grid-enterprise';
import type { IRow } from '../types/TableRows';

export const useRowSelection = (gridApi: React.RefObject<GridApi | null>) => {
  const [selectedRow, setSelectedRow] = useState<IRow | null>(null);
  const [comment, setComment] = useState('');
  const [breakId, setBreakId] = useState('');
  const [modalOpen, setModalOpen] = useState(false);

  const onSelectionChanged = () => {
    const selectedNodes = gridApi.current?.getSelectedNodes();
    const selectedData = selectedNodes?.[0]?.data as IRow | undefined;

    if (selectedData) {
      setSelectedRow(selectedData);
      setBreakId(selectedData.breakId);
      setModalOpen(true);
    }
  };

  const onRowClicked = (event: RowClickedEvent<IRow> | RowSelectedEvent<IRow>) => {
    const selectedData = event.data;
    setSelectedRow(selectedData!);
    setBreakId(selectedData?.breakId ?? '');
    setModalOpen(true);
  };

  const onRowSelected = (event: RowSelectedEvent<IRow>) => {
    const selectedData = event.data;
    setSelectedRow(selectedData!);
    setBreakId(selectedData?.breakId ?? '');
    setModalOpen(true);
  };

  const handleSaveComment = () => {
    if (selectedRow && gridApi.current) {
      const rowNode = gridApi.current.getRowNode(selectedRow.breakId);
      if (rowNode) {
        rowNode.setDataValue('userComment', comment);
      }
    }
    handleCloseModal();
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setComment('');
    setSelectedRow(null);

    if (gridApi.current && selectedRow) {
      const rowNode = gridApi.current.getRowNode(selectedRow.breakId);
      if (rowNode) {
        gridApi.current.ensureNodeVisible(rowNode, 'middle');

        requestAnimationFrame(() => {
          gridApi.current?.setFocusedCell(rowNode.rowIndex!, 'type');
        });
      }
    }
  };

  return {
    selectedRow,
    comment,
    setComment,
    breakId,
    modalOpen,
    onSelectionChanged,
    onRowClicked,
    onRowSelected,
    handleSaveComment,
    handleCloseModal,
  };
};
